module.exports = __webpack_public_path__ + "static/media/bot-bg-tablet.24220abc.png";